(function () {
  'use strict';

  var config = window.MonarkPromoCartConfig;
  if (!config) return;

  var promoIds = [
    Number(config.variants.suitCover),
    Number(config.variants.flyerM),
    Number(config.variants.flyerL)
  ];
  var promoIdSet = new Set(promoIds);
  var syncPromise = null;
  var syncRequestedAgain = false;
  var syncTimer = null;
  var checkoutBypass = false;

  function localeUrl(path) {
    var root = config.rootUrl || '/';
    return root.replace(/\/$/, '') + path;
  }

  function stateUrl() {
    return localeUrl('/?section_id=monark-promo-state&_=' + Date.now());
  }

  function requestOptions(body) {
    return {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    };
  }

  async function parseJsonResponse(response) {
    var data;
    try {
      data = await response.json();
    } catch (error) {
      throw new Error('Shopify returned an unreadable cart response.');
    }

    if (!response.ok || data.status) {
      throw new Error(data.description || data.message || 'Shopify rejected the promotional cart update.');
    }
    return data;
  }

  async function getPromoState() {
    var response = await fetch(stateUrl(), {
      credentials: 'same-origin',
      headers: {
        Accept: 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      },
      cache: 'no-store'
    });

    if (!response.ok) {
      throw new Error('Unable to read the promotional cart state.');
    }

    var html = await response.text();
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var stateElement = parsed.querySelector('[data-monark-promo-state]');
    if (!stateElement) {
      throw new Error('The promotional cart state section was not rendered.');
    }

    return JSON.parse(stateElement.textContent);
  }

  function desiredPromoIds(state) {
    if (Number(state.normalItemCount) < 1) return [];
    if (state.qualifiesLarge) {
      return [Number(config.variants.flyerL), Number(config.variants.suitCover)];
    }
    return [Number(config.variants.flyerM)];
  }

  function createPlan(state) {
    var desired = desiredPromoIds(state);
    var desiredSet = new Set(desired);
    var kept = new Set();
    var updates = {};

    state.lines.forEach(function (line) {
      var variantId = Number(line.variantId);
      if (!promoIdSet.has(variantId)) return;

      if (desiredSet.has(variantId) && !kept.has(variantId)) {
        kept.add(variantId);
        if (Number(line.quantity) !== 1) updates[line.key] = 1;
      } else {
        updates[line.key] = 0;
      }
    });

    var additions = desired.filter(function (variantId) {
      return !kept.has(variantId);
    });

    return {
      updates: updates,
      additions: additions,
      changed: Object.keys(updates).length > 0 || additions.length > 0
    };
  }

  async function applyPlan(plan) {
    if (Object.keys(plan.updates).length) {
      var updateResponse = await fetch(config.updateUrl, requestOptions({ updates: plan.updates }));
      await parseJsonResponse(updateResponse);
    }

    if (plan.additions.length) {
      var items = plan.additions.map(function (variantId) {
        return {
          id: variantId,
          quantity: 1,
          properties: { _monark_automatic_promotion: 'true' }
        };
      });
      var addResponse = await fetch(config.addUrl, requestOptions({ items: items }));
      await parseJsonResponse(addResponse);
    }
  }

  function dispatchCartRefresh() {
    function dispatch() {
      document.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        cancelable: true,
        detail: { source: 'monark-promo-cart' }
      }));
    }

    if (window.T4SThemeSP && window.T4SThemeSP.Cart) {
      dispatch();
      return;
    }

    var attempts = 0;
    var waitForKalles = window.setInterval(function () {
      attempts += 1;
      if (window.T4SThemeSP && window.T4SThemeSP.Cart) {
        window.clearInterval(waitForKalles);
        dispatch();
      } else if (attempts >= 40) {
        window.clearInterval(waitForKalles);
      }
    }, 100);
  }

  async function synchronizeOnce() {
    var changed = false;

    // A second pass verifies the final state and safely handles split promo
    // lines or a cart change that happened during the first request.
    for (var attempt = 0; attempt < 3; attempt += 1) {
      var state = await getPromoState();
      var plan = createPlan(state);
      if (!plan.changed) break;
      await applyPlan(plan);
      changed = true;
    }

    if (changed) dispatchCartRefresh();
    return true;
  }

  function synchronize() {
    if (syncPromise) {
      syncRequestedAgain = true;
      return syncPromise;
    }

    syncPromise = (async function () {
      var result = true;
      do {
        syncRequestedAgain = false;
        try {
          result = await synchronizeOnce();
        } catch (error) {
          result = false;
          console.error('[Monark promo cart]', error);
        }
      } while (syncRequestedAgain);
      return result;
    })().finally(function () {
      syncPromise = null;
    });

    return syncPromise;
  }

  function scheduleSync(delay) {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(function () {
      synchronize();
    }, typeof delay === 'number' ? delay : 80);
  }

  async function continueCheckout(target, form) {
    await synchronize();

    checkoutBypass = true;
    try {
      if (target && target.tagName === 'A') {
        window.location.assign(target.href || config.checkoutUrl);
        return;
      }

      if (target && target.isConnected && typeof target.click === 'function') {
        target.click();
        return;
      }

      if (form && form.isConnected) {
        var checkoutControl = form.querySelector('[name="checkout"]');
        if (checkoutControl && typeof form.requestSubmit === 'function') {
          form.requestSubmit(checkoutControl);
          return;
        }

        var checkoutInput = document.createElement('input');
        checkoutInput.type = 'hidden';
        checkoutInput.name = 'checkout';
        checkoutInput.value = 'Check out';
        form.appendChild(checkoutInput);
        HTMLFormElement.prototype.submit.call(form);
        return;
      }

      window.location.assign(config.checkoutUrl);
    } finally {
      window.setTimeout(function () {
        checkoutBypass = false;
      }, 0);
    }
  }

  document.addEventListener('cart:updated', function () {
    scheduleSync(50);
  });

  window.addEventListener('pageshow', function () {
    scheduleSync(30);
  });

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) scheduleSync(30);
  });

  // Final server-cart synchronization before the cart drawer or cart page is
  // allowed to continue to checkout.
  document.addEventListener('click', function (event) {
    if (checkoutBypass) return;

    var target = event.target.closest('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]');
    if (!target || !target.closest('[data-cart-wrapper]')) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    continueCheckout(target, target.closest('form'));
  }, true);

  document.addEventListener('submit', function (event) {
    if (checkoutBypass) return;

    var form = event.target;
    if (!form.matches('[data-cart-wrapper]')) return;

    var submitter = event.submitter;
    var isCheckout = submitter ? submitter.name === 'checkout' : Boolean(form.querySelector('[name="checkout"]'));
    if (!isCheckout) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    continueCheckout(submitter, form);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scheduleSync(0);
    }, { once: true });
  } else {
    scheduleSync(0);
  }
})();
